<footer class="footer" role="contentinfo">
  <div class="footer__content">
    <p>&copy; {{ currentYear }} Hüseyin Korkut – Full-Stack Engineer</p>

    <nav class="footer__links" aria-label="Footer Navigation">
      <a href="mailto:korkut@cloudfusion-it.de" title="E-Mail schreiben">E-Mail</a>
      <a href="https://calendly.com/korkut-cloudfusion-it" target="_blank" rel="noopener noreferrer" title="Termin buchen">Calendly</a>
      <a href="tel:+491632723457" title="Anrufen">+49 163 272 34 57</a>
      <a href="https://www.linkedin.com/in/hüseyin-korkut" target="_blank" rel="noopener noreferrer" title="LinkedIn">LinkedIn</a>
      <a href="https://www.xing.com/profile/Hueseyin_Korkut2" target="_blank" rel="noopener noreferrer" title="Xing">Xing</a>
      <a href="https://github.com/korkuth1" target="_blank" rel="noopener noreferrer" title="GitHub">GitHub</a>
      <a routerLink="/impressum" title="Impressum">{{ 'FOOTER.LEGAL_IMPRINT' | translate }}</a>
      <a routerLink="/datenschutz" title="Datenschutz">{{ 'FOOTER.LEGAL_PRIVACY' | translate }}</a>
    </nav>

    <div class="footer__badges">
      <a href="https://github.com/korkuth1" target="_blank" rel="noopener noreferrer">
        <img width="150" style="height: auto;" src="https://img.shields.io/badge/GitHub-korkuth1-181717?style=for-the-badge&logo=github" alt="GitHub Badge" />
      </a>
    </div>
  </div>
</footer>
